import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
  HttpErrorResponse,
} from '@angular/common/http';

import { inject } from '@angular/core';
import { AuthService } from '../shared/services/auth.service';
import { environment } from '../../environments/environment';
import { catchError, switchMap, throwError } from 'rxjs';
import { Router } from '@angular/router';

export const apiInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  let modifiedReq = req;

  if (req.url.startsWith('/api')) {
    modifiedReq = req.clone({
      url: req.url.replace('/api', `${environment.API_BASE}/api`),
    });
  } else if (req.url.startsWith('/v1')) {
    modifiedReq = req.clone({
      url: `${environment.API_OPERATION}${req.url}`,
    });
  }

  const token = authService.getAccessToken();

  if (token) {
    modifiedReq = modifiedReq.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  return next(modifiedReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        // Jeton expiré ou invalide
        return authService.refreshToken().pipe(
          switchMap(newToken => {
            if (!newToken) {
              authService.logout();
              setTimeout(() => {
                // window.location.reload();
              }, 0);
              return throwError(() => error);
            }

            const retryReq = modifiedReq.clone({
              setHeaders: {
                Authorization: `Bearer ${newToken}`,
              },
            });

            return next(retryReq);
          }),
          catchError(() => {
            // Le refresh a échoué → déconnexion
            authService.logout();
            setTimeout(() => {
              // window.location.reload();
            }, 0);
            return throwError(() => error);
          })
        );
      }

      return throwError(() => error);
    })
  );
};
